import styled from 'styled-components';
import { animated } from 'react-spring';
import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';

export const VehicleInfoWrapper = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-start;
  @media ${device.tablet} {
    flex-direction: column;
    /* align-items: flex-start; */
  }
`;

export const VehicleInfoContainer = styled(animated.div)`
  width: 100%;
  padding: 24px;
  background-color: ${COLORS.grey5};
  @media ${device.tablet} {
    padding: 0;
    background-color: initial;
  }
`;

export const MobileWrapper = styled(animated.div)`
  width: 100%;
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: 210px;
  background-color: ${COLORS.grey5};
  position: relative;
  @media ${device.tablet} {
    height: 168px;
  }
  @media ${device.laptop} {
    height: 224px;
  }
`;

export const VehicleImage = styled.img`
  width: 100%;
  position: absolute;
  top: 58%;
  transform: translateY(-50%);
`;

export const OfferType = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.05);
  width: fit-content;
  padding: 2px 12px;
  margin-top: 16px;
  font-family: Audi Type;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.002px;
  gap: 8px;
`;

export const Title = styled.h2<{ paddingTop?: boolean }>`
  padding-top: ${({ paddingTop }) => paddingTop && '24px'};
  font-family: Audi Type Extended;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0.002px;
  color: ${COLORS.grey80};
`;

export const VehicleName = styled.h2<{ isOfferPage?: boolean }>`
  padding-top: ${({ isOfferPage }) => (isOfferPage ? '8px' : '16px')};
  font-family: Audi Type Extended;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
  letter-spacing: 0.002px;
`;

export const Trimline = styled.h3`
  padding-top: 12px;
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
  color: ${COLORS.grey60};
`;

export const DealerDetails = styled.div<{ isGeneralForm: boolean }>`
  padding: 28px 0 36px 24px;
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
  @media ${device.tablet} {
    padding: 0;
    padding-top: ${({ isGeneralForm }) => !isGeneralForm && '32px'};
    margin-top: ${({ isGeneralForm }) => !isGeneralForm && '8px'};
  }
`;

export const DealerAddress = styled.div`
  padding-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
`;

export const DealerPhone = styled.div`
  padding-top: 24px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
`;

export const DealerText = styled.a`
  max-width: 200px;
  color: ${COLORS.black};
`;

export const ExposedButton = styled.div`
  width: 100%;
  padding: 16px 24px;
  border-top: 1px solid ${COLORS.grey15};
  border-bottom: 1px solid ${COLORS.grey15};
  font-family: Audi Type;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
`;

export const Header = styled.div``;

export const HeaderTitle = styled.p`
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
  color: ${COLORS.grey80};
  font-family: Audi Type;
`;

export const VehicleOfInterest = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.002px;
  color: ${COLORS.grey60};
`;

export const Vehicle = styled.div`
  max-width: 93%;
`;

export const OfferShortDetails = styled.div`
  font-family: Audi Type;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.002px;
  color: ${COLORS.grey60};
`;

export const OffersWrapper = styled.div`
  margin-top: 24px;
`;

export const MainOffer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const BonusOffer = styled.div`
  color: ${COLORS.grey80};
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-top: 32px;
`;

export const AprOrPayment = styled.div<{ isFinanceOffer: boolean }>`
  padding-right: ${({ isFinanceOffer }) => (isFinanceOffer ? '28px' : '12px')};
  border-right: 1px solid ${COLORS.grey15};
`;
export const Term = styled.div<{ isFinanceOffer: boolean }>`
  padding-left: ${({ isFinanceOffer }) => (isFinanceOffer ? '28px' : '12px')};
  padding-right: 12px;
`;
export const DownPayment = styled.div`
  padding-left: 12px;
  border-left: 1px solid ${COLORS.grey15};
`;

export const PaymentNumber = styled.h3`
  color: ${COLORS.grey80};
  font-family: Audi Type;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.002px;
`;
export const PaymentLabel = styled.p`
  color: ${COLORS.grey60};
  font-family: Audi Type;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.002px;
`;

export const CreditBonus = styled.h2`
  font-family: Audi Type Extended;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.002px;
  margin-top: 8px;
  @media ${device.laptop} {
    font-size: 24px;
    line-height: 36px;
    letter-spacing: 0.002px;
    margin-top: 12px;
  }
`;

export const CreditBonusDescription = styled.h2`
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
  color: ${COLORS.grey80};
  margin-top: 8px;
  @media ${device.laptop} {
    margin-top: 12px;
  }
`;

export const OpenTimeWrapper = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;
export const OpenTimeTable = styled.div`
  margin-left: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
export const OpenTime = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
export const OpenDays = styled.div`
  width: 72px;
`;
export const OpenHours = styled.div``;
